/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockFastIcon64Regular = forwardRef('TimeClockFastIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M32 9C19.297 9 9 19.297 9 32a1.5 1.5 0 0 1-3 0C6 17.64 17.64 6 32 6s26 11.64 26 26-11.64 26-26 26a1.5 1.5 0 0 1 0-3c12.703 0 23-10.297 23-23S44.703 9 32 9Z" }),
        React.createElement("path", { d: "M30.5 18a1.5 1.5 0 0 1 1.5 1.5v10.528a2.5 2.5 0 0 0 1.382 2.236l8.789 4.394a1.5 1.5 0 1 1-1.342 2.684l-8.789-4.395a5.5 5.5 0 0 1-3.04-4.92V19.5a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M6.5 55a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3h-17Z" }),
        React.createElement("path", { d: "M0 49.5A1.5 1.5 0 0 1 1.5 48h15a1.5 1.5 0 0 1 0 3h-15A1.5 1.5 0 0 1 0 49.5Z" }),
        React.createElement("path", { d: "M4.5 41a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3h-7Z" })));
});
